import { TextField } from '@mui/material'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

/**
 * Renders a text input field wrapped in a react-hook-form Controller component.
 *
 * @author Maria Eduarda Franke
 * 
 * @param {string} props.name - The name of the input field.
 * @param {string} props.label - The label for the input field.
 * @param {Object} props.control - The react-hook-form control object.
 * @param {Object} props.errors - The errors object from react-hook-form.
 * @param {Object} props... - Additional props to be passed to the TextField component.
 * @returns {JSX.Element} - The rendered text input field.
 */
const FormInputText = ({ name, label, control, errors, ...props }) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <TextField
                    {...field}
                    type='text'
                    label={label}
                    placeholder={label}
                    error={!!errors}
                    helperText={errors?.message}
                    InputLabelProps={{ shrink: true }}
                    {...props}
                />
            )}
        />
    )
}

FormInputText.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object
}

export default FormInputText